import { render, staticRenderFns } from "./ResourcesMngt.vue?vue&type=template&id=d81d98da&scoped=true"
import script from "./ResourcesMngt.vue?vue&type=script&lang=js"
export * from "./ResourcesMngt.vue?vue&type=script&lang=js"
import style0 from "./ResourcesMngt.vue?vue&type=style&index=0&id=d81d98da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81d98da",
  null
  
)

export default component.exports